import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { actions } from '../../store/ducks/attachments';
import TStore from '../../types/store';
import { TAttachmentDB } from '../../types/db';
import { TPatientDetail } from '../../types/patients';
import AttachmentCell from './attachment-cell';
import { AttachmentsGallerySC } from './attachments-gallery.styled';
// import Attachments from '../../pages/chat/components/attachments';
import { FormattedMessage } from 'react-intl';
import { HearthBeatLoader } from '@components/ui';

type TType = 'ROOM' | 'DIRECT_CHAT';

type TProps = {
  type: TType;
  loading: boolean;
  messagesLoading: boolean;
  attachments: TAttachmentDB[];
  getAttachmentsRequest(type: TType): void;
};

const AttachmentsGallery: React.FC<TProps> = ({
  type,
  messagesLoading,
  loading,
  attachments,
  getAttachmentsRequest,
}: TProps) => {
  const [fullName, setFullName] = useState('');

  const patientDetail: TPatientDetail | null = useSelector(
    (store: TStore) => store.patients.patientDetail,
  );

  useEffect(() => {
    if (patientDetail !== null) {
      const {
        profile: { firstName, lastName },
      } = patientDetail;

      setFullName(firstName + ' ' + lastName);
    }
  }, [patientDetail]);

  useEffect(() => {
    if (!messagesLoading) {
      console.log('Get attachments');
      getAttachmentsRequest(type);
    }
  }, [getAttachmentsRequest, type, messagesLoading]);

  const renderAttachments = (name: string) =>
    attachments.length > 0 ? (
      attachments.map((attachment) => (
        <AttachmentCell key={attachment.id} attachment={attachment} />
      ))
    ) : (
      <div className="ag-empty">
        <FormattedMessage id="attachment.empty_for_person" values={{ name: name }} />
      </div>
    );

  return (
    <AttachmentsGallerySC>
      <div className="ag-wrapper clearfix">
        {loading || messagesLoading ? (
          <div className="ag-loading">
            <HearthBeatLoader loading size="medium" />
            {/* <img src={require('../../assets/gif/hilbi-loader.gif').default} alt="Loading" /> */}
          </div>
        ) : (
          renderAttachments(fullName ? fullName : '')
        )}
      </div>
    </AttachmentsGallerySC>
  );
};

const mapStateToProps = (state: TStore) => ({
  attachments: state.attachments.attachments,
  loading: state.attachments.loading,
  profile: state.patients.patientDetail,
});

const mapDispatchToProps = (dispatch: any) => ({
  getAttachmentsRequest: (type: TType) => dispatch(actions.getAttachmentsRequest(type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentsGallery);
